<template>
    <div class="datamain">
        <Header />

        <div class="datamenubox">
            <div :class="menu == 'chart' ? 'datamenuitem died' : 'datamenuitem'" @click="menuchange('chart')" need-listen data-event-name="goDataTrend">数据趋势</div>
            <div :class="menu == 'table' ? 'datamenuitem died' : 'datamenuitem'" @click="menuchange('table')" need-listen data-event-name="goDataPoint">监测点数据
            </div>
            <div :class="menu == 'warn' ? 'datamenuitem died' : 'datamenuitem'" @click="menuchange('warn')" need-listen data-event-name="goDataWarn">AI预警和任务
            </div>
        </div>
        <div class="databox">
            <Chart v-if="menu == 'chart'" :key="'chart'" :sbname="sbname" />
            <Table 
                v-if="menu == 'table'" 
                :key="'table'" 
                :sbname="sbname"
                :initial-device-id="initialDeviceId"
                :initial-greenhouse-id="initialGreenhouseId"
                :initial-device-name="sbname"
            />
            <Warn v-if="menu == 'warn'" :key="'warn'" :sbname="sbname" />
        </div>
    </div>

</template>

<script>
import router from '../router'
import axios from "axios";
import * as echarts from 'echarts';
import Chart from '../components/data_chart.vue'
import Table from '../components/data_table.vue'
import Warn from '../components/data_warn.vue'

import Header from './Header.vue'
export default {
    name: 'index',
    components: {
        Header,
        Chart,
        Table,
        Warn,
    },
    data() {
        return {
            menu: 'chart',
            sbname: '',
            drawer: false,
            initialDeviceId: '', // 初始设备ID
            initialGreenhouseId: '', // 初始大棚ID
        }
    },
    computed: {

    },
    mounted() {
        console.log(this.$router.history.current.query)
        const data = this.$router.history.current.query
        if (data.t && data.t == 'table') {
            this.menu = 'table'
            this.sbname = data.n || ''
            // 接收设备ID和大棚ID
            this.initialDeviceId = data.deviceId || ''
            this.initialGreenhouseId = data.greenhouseId || ''
        } else if (data.t && data.t == 'chart') {
            this.menu = 'chart'
            this.sbname = data.n || ''
        } else if (data.t == 'warn') {
            this.menu = 'warn'
        }
    },
    methods: {
        menuchange(e) {
            this.menu = e
        },
        handleClose() {
            this.drawer = false
        },
    }
}




</script>

<style scoped lang="less">
@font-face {
    font-family: 'title';
    src: url('../assets/font/title.ttf');
}

.datamain {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #030a2e;

    .datamenubox {
        margin: 10px;
        height: 50px;
        display: flex;
        align-items: center;
        padding-left: 10px;

        .datamenuitem {
            padding: 10px 20px;
            color: #fff;
            font-size: 22px;
            cursor: pointer;
            background-image: url('../assets/img/data/btn.png');
            background-size: 100% 100%;
        }

        .died {
            background-image: url('../assets/img/data/btned.png');
        }
    }

    .databox {
        margin: 10px;
        width: calc(100% - 20px);
        height: calc(100% - 160px);
        background: rgba(0, 11, 47, 0.5);
        box-shadow: inset 0px 0px 20px 0px rgba(0, 124, 255, 0.5);
        border-radius: 0px 0px 0px 0px;
        padding: 10px;
        display: flex;
    }


}
</style>
